export const contactData = {
  companyName: 'Dave & Associates',
  companyFullName: 'Dave & Associates Chartered Accountants',
  email: 'office@casdave.co.in',
  phone: '+91 7940329623',
  address: {
    line1: '208, Maurya Complex, Navjeevan Press Road',
    line2: 'Nr. Income Tax Cross Road',
    city: 'Ahmedabad',
    state: 'Gujarat',
    pincode: '380014',
    country: 'India'
  },
  fullAddress: '208, Maurya Complex, Navjeevan Press Road, Nr. Income Tax Cross Road, Ahmedabad - 380014, Gujarat, India',
  website: 'www.casdave.co.in',
  social: {
    facebook: '#',
    linkedin: 'https://www.linkedin.com/company/dave-associates-chartered-accountants/'
  },
  mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3489.828317696675!2d72.56519007509242!3d23.042468179159876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8500473f4955%3A0x91e7626bf1967e9f!2sDave%20%26%20Associates%2C%20Chartered%20Accountant!5e1!3m2!1sen!2sin!4v1774880912030!5m2!1sen!2sin',
  officeHours: 'Monday - Saturday: 10:00 AM - 7:00 PM',
  serviceInterests: [
    'Direct Taxes',
    'Indirect Taxes (GST)',
    'Project Financing',
    'Subsidy Consultancy',
    'ROC & Company Law',
    'Audit Services',
    'Virtual CFO',
    'Advisory Services',
    'Other'
  ]
};

